<template>
  <div
    class="content-wrapper view-aptlist-manage p-0"
    :class="{
      'standalone-clinic': isStandaloneClinic,
    }"
  >
    <div class="content">
      <div class="card">
        <div class="card-body">
          <div class="header-topic">
            <h4><i class="fas fa-boxes"></i> สินค้าและสต๊อก</h4>

            <div class="last-updated">อัปเดตล่าสุด {{ lastUpdated }}</div>
          </div>

          <div class="row mx-1 my-3">
            <b-form-input
              type="search"
              class="col w-full"
              autofocus
              v-model="filter"
              placeholder="ค้นหาสินค้า จากรหัส หมวดหมู่ หรือชื่อสินค้า"
            ></b-form-input>
            <b-button
              class="w-full ml-3 btn-adjust-disabled"
              variant="outline-primary"
              :disabled="!isSomeBoxChecked"
              @click="openProductSelectedItemModal()"
              v-if="isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER'])"
            >
              <i class="fas fa-pencil-square-o"></i>
              ปรับปรุงสต๊อกจากสินค้าที่เลือก
            </b-button>
            <b-button
              class="w-full ml-3 btn-adjust-disabled"
              variant="outline-primary"
              :disabled="isSomeBoxChecked"
              @click="openStockAdjustmentModal()"
              v-if="isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER'])"
            >
              <i class="fas fa-pencil-square-o"></i> ปรับปรุงสต๊อก
            </b-button>
            <b-button
              v-if="
                this.getBranchInfo.clinic.type === ClinicType.STANDALONE &&
                this.isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER'])
              "
              class="w-full ml-3 btn-add-disabled"
              :disabled="isSomeBoxChecked"
              variant="primary"
              @click="openProductItemModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
          </div>
          <div
            :class="{
              'has-box-column': isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER']),
              'no-box-column': !isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER']),
            }"
          >
            <b-table
              id="productManageTable"
              ref="productManageTable"
              hover
              small
              sort-icon-left
              head-variant="light"
              :items="getProductList"
              :fields="fields"
              :filter="filter"
              :filter-function="filterProducts"
              :sort-desc="true"
              :responsive="true"
            >
              <template v-slot:head(box)>
                <b-form-checkbox
                  :checked="isAllBoxChecked"
                  :indeterminate="isSomeBoxChecked && !isAllBoxChecked"
                  @change="toggleAllBox($event)"
                />
              </template>

              <template v-slot:cell(box)="row">
                <b-form-checkbox v-model="row.item.box"></b-form-checkbox>
              </template>

              <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>

              <template v-slot:cell(productPrice)="row">
                {{ formatProductPrice(row.value) }}
              </template>

              <template v-slot:cell(productStock)="row">
                <div class="product-stock-content">
                  {{ formatProductStock(row.value) }}
                  <i
                    class="fas fa-info-circle ml-1 info-icon"
                    @click="openProductHistoryItemModal(row.item)"
                  ></i>
                </div>
              </template>

              <template v-slot:cell(buttons)="row">
                <ActionButtonGroup
                  :item="row.item"
                  :show-info="false"
                  edit-tooltip="แก้ไขสินค้า"
                  delete-tooltip="ลบสินค้า"
                  @edit="editProduct"
                  @delete="deleteProduct"
                  :disabled-delete="row.item.productStatus === Status.LOCKED"
                />
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <ProductHistoryItem ref="productHistoryItemModal"></ProductHistoryItem>
      <ProductItem ref="productItemModal"></ProductItem>
      <StockAdjustmentModal ref="stockAdjustmentModal"></StockAdjustmentModal>
      <ProductSelectedItem ref="productSelectedItemModal"></ProductSelectedItem>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import ProductItem from "../../components/modal/ProductAndStock/ProductItem.vue";
import StockAdjustmentModal from "../../components/modal/ProductAndStock/StockAdjustment.vue";
import ProductSelectedItem from "../../components/modal/ProductAndStock/ProductSelectedItem.vue";
import Dialog from "../../components/modal/Dialog.vue";
import { mapGetters, mapActions } from "vuex";
import Loading from "@/components/Loading";
import ProductHistoryItem from "../../components/modal/ProductAndStock/ProductHistoryItem.vue";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";
import { ClinicType, Status } from "../../constants/productStock";
import { formatShortDateTime } from "../../utils/utils";

export default {
  name: "ProductInventory",
  components: {
    ProductItem,
    StockAdjustmentModal,
    ProductSelectedItem,
    Dialog,
    Loading,
    ProductHistoryItem,
    ActionButtonGroup,
  },
  data() {
    return {
      isLoading: false,
      filter: "",
      ClinicType,
      Status,
      lastUpdated: "",
    };
  },
  created() {
    this.init();
    this.lastUpdated = formatShortDateTime(new Date());
  },
  computed: {
    ...mapGetters({
      getProductList: "moduleProductInventory/getProductList",
      getProductUnitList: "moduleUnitMaster/getUnitList",
      getCategoryList: "moduleCategoryMaster/getCategoryList",
      getAllGRWithProductList: "moduleProductInventory/getAllGRWithProductList",
      getBranchInfo: "moduleUser/getBranchInfo",
      isAccessMenu: "moduleUser/getIsAccessMenu",
    }),
    fields() {
      const baseFields = [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "productCode",
          label: "รหัส",
          sortable: true,
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
        {
          key: "productCategory.description",
          label: "หมวดหมู่",
          sortable: true,
          thStyle: { width: "10%" },
          tdStyle: { width: "10%" },
        },
        {
          key: "productNameMain",
          label: "ชื่อสินค้า",
          sortable: true,
        },
        {
          key: "productNameAdditional",
          label: "ชื่อสินค้าเพิ่มเติม",
          sortable: true,
        },
        {
          key: "productStock",
          label: "จำนวนสต๊อก",
          sortable: true,
          thStyle: { width: "11%" },
          tdStyle: { width: "11%" },
          tdClass: "product-stock-cell",
          thClass: "text-right",
        },
        {
          key: "productUnit.description",
          label: "หน่วย",
          sortable: true,
          thStyle: { width: "10%" },
          tdStyle: { width: "10%" },
        },
      ];
      if (this.getBranchInfo?.clinic?.type !== ClinicType.CHAIN) {
        baseFields.push({
          key: "productPrice",
          label: "ราคาต้นทุนเฉลี่ย (บาท)",
          sortable: true,
          thStyle: { width: "11%" },
          tdStyle: { width: "11%" },
          tdClass: "product-stock-cell",
          thClass: "text-right",
        });
      }
      if (
        this.getBranchInfo?.clinic?.type === ClinicType.STANDALONE &&
        this.isAccessMenu(["ROLE_BRANCH_STOCK_MANAGER"])
      ) {
        baseFields.push({
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        });
      }
      if (this.isAccessMenu(["ROLE_BRANCH_STOCK_MANAGER"])) {
        baseFields.unshift({
          key: "box",
          label: "box",
          thStyle: { width: "4%" },
          tdStyle: { width: "4%" },
        });
      }
      return baseFields;
    },
    productList() {
      return this.getProductList || [];
    },
    isAllBoxChecked() {
      const list = this.productList;
      return list.length > 0 && list.every(item => item.box === true);
    },
    isSomeBoxChecked() {
      return this.productList.some(item => item.box === true);
    },
    isStandaloneClinic() {
      return this.getBranchInfo?.clinic?.type === ClinicType.STANDALONE;
    },
  },
  methods: {
    ...mapActions({
      fetchProductList: "moduleProductInventory/fetchProductList",
      fetchUnitList: "moduleUnitMaster/fetchUnitList",
      fetchCategoryList: "moduleCategoryMaster/fetchCategoryList",
      fetchAllGRWithProductList:
        "moduleProductInventory/fetchAllGRWithProductList",
    }),
    async init() {
      this.isLoading = true;
      try {
        const clinicUrl = this.$route.params.clinicUrl;
        const branchUrl = this.$route.params.branchUrl;
        const promises = [
          this.fetchProductList({ clinicUrl, branchUrl }),
          this.fetchUnitList({ clinicUrl, branchUrl }),
          this.fetchCategoryList({ clinicUrl, branchUrl }),
        ];
        if (this.isAccessMenu(["ROLE_BRANCH_STOCK_MANAGER"])) {
          promises.push(
            this.fetchAllGRWithProductList({ clinicUrl, branchUrl })
          );
        }
        await Promise.all(promises);
      } catch (err) {
        this.showDialogToast("danger", "โหลดรายการสินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    openProductItemModal(product = null) {
      this.$refs.productItemModal.show({
        product,
        unitList: this.getProductUnitList,
        categoryList: this.getCategoryList,
      });
    },
    openProductSelectedItemModal() {
      const selectedProducts = this.getProductList.filter(item => item.box);
      this.$refs.productSelectedItemModal.show({
        selectedProducts,
        productList: this.getProductList,
      });
    },
    editProduct(product) {
      this.openProductItemModal(product);
    },
    deleteProduct(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบสินค้านี้ ?",
        "คุณต้องการลบสินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;

        this.isLoading = true;

        this.$store
          .dispatch("moduleProductInventory/deleteProductItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: eventData.productId,
          })
          .then(res => {
            if (res.status == 200) {
              this.init();
              this.showDialogToast("success", "ลบรายการสินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    openProductHistoryItemModal(product) {
      this.isLoading = true;

      this.$store
        .dispatch("moduleProductInventory/getProductHistoryById", {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id: product.productId,
        })
        .then(res => {
          const historyData = res.data.data;
          this.$refs.productHistoryItemModal.show({
            historyData,
            productUnit: product.productUnit.description,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    openStockAdjustmentModal() {
      this.$refs.stockAdjustmentModal.show({
        productList: this.getProductList,
        unitList: this.getProductUnitList,
        allGRWithProductList: this.getAllGRWithProductList,
      });
    },
    filterProducts(row, filter) {
      if (!filter || (typeof filter === "string" && !filter.trim())) {
        return true;
      }
      const s = String(filter).toLowerCase();
      const code = (row.productCode || "").toString().toLowerCase();
      const category = (
        row.productCategory?.description ??
        row.productCategory ??
        ""
      )
        .toString()
        .toLowerCase();
      const nameMain = (row.productNameMain || "").toString().toLowerCase();
      const nameAdditional = (row.productNameAdditional || "")
        .toString()
        .toLowerCase();
      return (
        code.includes(s) ||
        category.includes(s) ||
        nameMain.includes(s) ||
        nameAdditional.includes(s)
      );
    },
    formatProductPrice(value) {
      if (value == null || value === "") return "";
      const num = Number(value);
      if (Number.isNaN(num)) return "";
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatProductStock(value) {
      if (value == null || value === "") return "";
      const num = Number(value);
      if (Number.isNaN(num)) return "";
      return num.toLocaleString("en-US");
    },
    toggleAllBox(checked) {
      this.productList.forEach(item => {
        this.$set(item, "box", checked);
      });
    },
  },
};
</script>

<style scoped>
.info-icon {
  color: #a3a4a6;
  cursor: pointer;
  font-size: 20px;
}

::v-deep #productManageTable thead tr th,
::v-deep #productManageTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #productManageTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #productManageTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep .product-stock-cell {
  vertical-align: middle !important;
  text-align: right !important;
}
::v-deep .product-stock-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.no-box-column
  ::v-deep
  #productManageTable
  thead
  tr
  th:nth-child(6)[aria-sort] {
  background-position: left 30px center;
}

.has-box-column
  ::v-deep
  #productManageTable
  thead
  tr
  th:nth-child(7)[aria-sort] {
  background-position: left 30px center;
}

@media (max-width: 1140px) {
  .no-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(6)[aria-sort] {
    background-position: left 24px center;
  }
}
@media (max-width: 1140px) {
  .has-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(7)[aria-sort] {
    background-position: left 24px center;
  }
}

@media (max-width: 1060px) {
  .no-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(6)[aria-sort] {
    background-position: left 20px center;
  }
}
@media (max-width: 1060px) {
  .has-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(7)[aria-sort] {
    background-position: left 20px center;
  }
}

@media (max-width: 990px) {
  .no-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(6)[aria-sort] {
    background-position: left 16px center;
  }
}
@media (max-width: 990px) {
  .has-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(7)[aria-sort] {
    background-position: left 16px center;
  }
}

/* -------- */

.standalone-clinic
  .no-box-column
  ::v-deep
  #productManageTable
  thead
  tr
  th:nth-child(8)[aria-sort] {
  background-position: left 13px center !important;
}

.standalone-clinic
  .has-box-column
  ::v-deep
  #productManageTable
  thead
  tr
  th:nth-child(9)[aria-sort] {
  background-position: left 10px center;
}

@media (max-width: 1140px) {
  .standalone-clinic
    .no-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(8)[aria-sort] {
    background-position: left 10px center;
  }
}
@media (max-width: 1140px) {
  .standalone-clinic
    .has-box-column::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(9)[aria-sort] {
    background-position: left 24px center;
  }
}

@media (max-width: 1060px) {
  .standalone-clinic
    .no-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(8)[aria-sort] {
    background-position: left 8px center !important;
  }
}
@media (max-width: 1060px) {
  .standalone-clinic
    .has-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(9)[aria-sort] {
    background-position: left 20px center;
  }
}

@media (max-width: 990px) {
  .standalone-clinic
    .no-box-column
    ::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(8)[aria-sort] {
    background-position: left 4px center !important;
  }
}
@media (max-width: 990px) {
  .standalone-clinic
    .has-box-column::v-deep
    #productManageTable
    thead
    tr
    th:nth-child(9)[aria-sort] {
    background-position: left 16px center;
  }
}

.btn-adjust-disabled:disabled {
  color: #ebebeb !important;
  border-color: #ebebeb !important;
}

.btn-add-disabled:disabled {
  color: #c6c6c6 !important;
  background-color: #ebebeb;
  border-color: transparent !important;
}

.header-topic {
  display: flex;
  gap: 8px;
  align-items: center;
}

.last-updated {
  padding-bottom: 5px;
  color: #6d747d;
  font-size: 14px;
}
</style>
